// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"b3da1bc7","952":"5f72a911"}[chunkId] + ".chunk.js";
};